export const SIDE_PANE_NEW_ITEMS_KEY = 'SidePaneNewItems';
export const A2HS_BANNER = 'A2HSBanner';
